import React, { memo } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ArrowRightIcon } from 'lucide-react';
interface CategorySpecificShowcaseProps {
  title: string;
  subtitle?: string;
  description?: string;
  viewAllLink: string;
  backgroundColor: string;
  textColor: string;
  iconColor: string;
  products: any[];
  icon?: React.ReactNode;
}
export const CategorySpecificShowcase = memo(function CategorySpecificShowcase({
  title,
  subtitle,
  description,
  viewAllLink,
  backgroundColor,
  textColor,
  iconColor,
  products,
  icon
}: CategorySpecificShowcaseProps) {
  return <div className="w-full" data-id="element-2150" data-mp="qbpykle4p4dz">
      <div className="container mx-auto px-4" data-id="element-2151" data-mp="qaeknsqyyg95">
        <div className={`rounded-xl overflow-hidden ${backgroundColor} p-6 md:p-8 mb-6`} data-id="element-2152" data-mp="vasu9f87xy9a">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2153" data-mp="21ro1e7ipqu6r">
            <div className="mb-4 md:mb-0" data-id="element-2154" data-mp="26ppvdnhogdx0">
              {subtitle && <span className={`text-xs font-bold ${iconColor} bg-white bg-opacity-90 px-2 py-0.5 rounded-full mb-2 inline-block uppercase`} data-id="element-2155" data-mp="26s291ogek249">
                  {subtitle}
                </span>}
              <h2 className={`text-2xl md:text-3xl font-bold ${textColor} flex items-center`} data-id="element-2156" data-mp="2zt3pv8xw2mr1">
                {icon && <span className="mr-2" data-id="element-2157" data-mp="2ux67yy6z98c5">{icon}</span>}
                {title}
              </h2>
              {description && <p className={`${textColor} text-opacity-90 mt-1 text-sm max-w-xl`} data-id="element-2158" data-mp="2l5ilzct6wji2">
                  {description}
                </p>}
            </div>
            <a href={viewAllLink} className={`${iconColor} bg-white bg-opacity-90 hover:bg-opacity-100 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center`} data-id="element-2159" data-mp="2c4u3o5wrjwzd">
              View All
              <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2160" data-mp="226wgzmujy88v" />
            </a>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2161" data-mp="1shh7p2vikard">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-2162" data-mp="1ikmaqoew2if7" />)}
        </div>
      </div>
    </div>;
});